import { string, object, number } from 'yup';

// Esquema para validar la dirección del usuario
const userAddressSchema = object({
  line1: string().required().min(5),
  countryCode: string().required().length(2),
  city: string().required().min(2),
  postalCode: string().required(),
});

// Esquema de validación para `UserDTO`
const validateUserSchema = object({
  id: number().required(),

  firstName: string().required().min(2),
  lastName: string().required().min(2),

  email: string().email().required(),

  dob: string().required(),

  userAddress: userAddressSchema,
});

export default validateUserSchema;
